import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";
import Chart from "./Chart/Chart";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="Counties struggle to improve contact tracing"
            subtitle="Many of Pennsylvania's largest counties have far fewer contact tracers than some experts say are needed to prevent new coronavirus outbreaks. With little state or federal help, many counties are relying on county employees or volunteers to bolster their ranks. Others are relying on hospital systems or local nonprofits."
          />
          <Body>
            <Chart data={data} dataKey="county" />
          </Body>
          <Footer
            byline="Daniel Simmons-Ritchie"
            source="Number of needed contact tracers is based on estimates from George Washington University (June 15, 2020). Number of current and planned contact tracers is based on a Spotlight PA/Philadelphia Inquirer survey of county health departments and county contractors (June, 2020)."
            footnote='Note: Numbers do not capture state public health nurses and may not capture tracers working through independent organizations that are not directly employed or contracted by the county. "Potential additional tracers" reflects the number of tracers counties said they plan to add should they determine they are needed. Philadelphia and Allegheny Counties said they plan to add tracers but did not provide exact numbers.'
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default Main;
